import Alpine from "alpinejs";

const apiUrl = window.location.origin + '/api/financo/simulation/';

document.addEventListener('alpine:init', () => {
    Alpine.data('initFinanco', () => {
        return {
            // Set range value base value
            rangeValue: 48,
            // Set base value of amount
            amount: 5000,
            // Set base value of contribution
            contribution: 1000,
            // Set base status for tab
            tabOpen: false,
            // Response values
            legalText: null,
            loan: null,
            // loading state
            loading: false,
            // error message
            errorMessage: '',
            handleTab() {
                this.tabOpen = !this.tabOpen;
            },
            handleRange(value: number) {
                this.rangeValue = value;
                this.handleRequest()
            },
            handleAmount(value: number) {
                if (value) {
                    this.amount = value;
                } else {
                    this.amount = 5000
                }
                this.handleRequest()
            },
            handleContribution(value: number) {
                if (value) {
                    this.contribution = value;
                } else {
                    this.contribution = 1000;
                }
                this.handleRequest()
            },
            handleRequest() {
                this.loading = true
                const getDatas = fetch(apiUrl, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        loan: {
                            "depositAmount": this.contribution,
                            "purchaseAmount": this.amount,
                            "numberOfPayments": this.rangeValue,
                            "paymentPostponement": "6",
                            "borrowerInsuranceId": "1"
                        },
                        professional: "false",
                        legalNotices: "true",
                        referrer: window.location.href,
                    })
                })
                    .then((response: any) => {
                        this.loading = false
                        return response.json();
                    })

                getDatas.then((response: any) => {
                    if (response.message) {
                        this.errorMessage = response.message;
                    } else {
                        this.errorMessage = '';
                    }
                    this.legalText = response.legalNotices.html;
                    this.loan = response.loan;
                }).catch((err) => {
                    console.log(err)
                })
            }
        }
    })
})
